/*
	Abre o menu
*/
export default (state) => 
	state.aside.isOpen = true

	
